import React, { useEffect } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { getOgaLeadsStudents } from '../../../../redux/features/ogdSlice';
import { QUALIFIED_LEADS_TABLE_HEAD } from '../../../../components/datagrid/myworkspace/ogd/QualifiedLeadsTableHead';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import { Box, Paper } from '@mui/material';
import ActionDetails from '../../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../../components/mui/GlobalAnchor/GlobalAnchorList';
import StudentEdit from '../../../../components/datagrid/myworkspace/ogd/AdmissionRegister/StudentEdit';
import { getClassPreData, getSyllabusPreData } from '../../../../redux/features/assessmentToolSlice';
import { getMediums } from '../../../../redux/features/croSlice';
import { getCountryPreData, getLocalBodyPreData } from '../../../../redux/features/generalSlice';
import CopyDataToSheet from '../../../../components/CopyDataToSheet';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';

const CartLeads = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { ogaLeadStudents, loading } = useSelector((state) => state.ogd);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const firstRender = React.useRef(true);
  // const newData = { ...rowData, admissionNo: rowData?.admnNo };
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
    openAnchor,
  };
  useEffect(() => {
    dispatch(getClassPreData());
    dispatch(getSyllabusPreData());
    dispatch(getMediums());
    dispatch(getLocalBodyPreData());
    dispatch(getCountryPreData());
  }, []);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (pageNum && gridSize) {
      dispatch(getOgaLeadsStudents(data));
    }
  }, [pageNum, gridSize]);
  useEffect(() => {
    if (pageNum !== 1) {
      dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
    } else {
      dispatch(getOgaLeadsStudents(data));
    }
  }, [search]);

  return (
    <GlobalWrapper title="Qualified Leads">
      {/* <CopyDataToSheet api={getOgaLeadsStudents(datas)} loading={loading} /> */}
      <Paper elevation={3}>
        <Box sx={{ width: '100%', padding: 0 }}>
          <GlobalDatagrid
            tableHead={QUALIFIED_LEADS_TABLE_HEAD(ogaLeadStudents?.data)}
            rows={ogaLeadStudents?.data || []}
            meta={ogaLeadStudents?.meta?.totalRecords || 0}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={profile?.roleID === 110 || profile?.roleID === 12 || profile?.roleID === 106 ? true : false}
            actionComponent={
              <>
                <ActionDetails val={rowData?.name} />
                <GlobalAnchorList component={<StudentEdit croedit={true} rowData={rowData} />} />
              </>
            }
          />
        </Box>
      </Paper>
    </GlobalWrapper>
  );
};

export default CartLeads;
